<template>

  <div id="loginbg">  ·
    <div id="ding">
      <div class="title"id="wenzi">
        自提系统
      </div>
      <div class="title"id="zhanghao">
        账号
      </div>
      <div class="title"id="tuichu"@click="logout">
        【退出】
      </div>
      <div class="title"id="yuyue" @click="tiaozhuanyuyue">
        预约
      </div>
      <div class="title"id="basic" @click="shouye">
        首页
      </div>
    </div>
    <div style="position: absolute;background-color: white;top: 71px;width: 80%;left: 140px;height: 60px;">
      <el-button id="xiugai "type="primary" style="position: absolute;left: 20px;top: 16px;" size="mini"@click="handleEdit()">修改</el-button>
      <el-button id="quxiao" type="danger" style="position: absolute;left: 75px;top: 16px;" size="mini"@click="handleDelete()">删除</el-button>
      <!--action="http://localhost:8881/excel/importLogistics"-->
      <el-col :span="12" >
        <el-upload
                class="upload-demo"
                action="/api/excel/importOrderProduct"
                :limit="1"
                :headers="headers"
                :on-exceed="handleExceed"
                :before-upload="handleBeforeUpload"
                :multiple="false"
                :on-success="handlesuccess"
                :on-error="handleerror"
        >
          <el-button id="daoRu" size="mini" type="primary"style="margin-left: 150px;margin-top: 16px;" >批量导入</el-button>
        </el-upload>
      </el-col>
      <el-button id="daochu" type="primary"  style="position: absolute;left: 240px;top: 16px;" size="mini"@click="handleadd()">单个录入</el-button>
      <el-input v-model="gaojichaxuntemp" style="position: absolute;left: 390px;width: 220px;top: 11px" placeholder="订单号或提货卡号或电话"clearable>
      </el-input>
      <!--<img src="../../assets/Search.png"style="position: absolute;left: 630px;top: 18px;width: 70px;" @click="gaojichaxun()">-->
      <el-button type="primary"size="mini" style="position: absolute;left: 620px;top: 18px;border-radius:4px;"icon="el-icon-search"@click="gaojichaxun()">搜索</el-button>
    </div>

    <!-- <el-divider id="fengexian"></el-divider>-->
    <el-table :data="pageData.rows" v-loading="listLoading"
              size=mini style="width: 80%; left: 140px;height:580px;top: 74px;"@selection-change="selsChange">
      <el-table-column type="selection" width="55">
      </el-table-column>
      <el-table-column prop="id" label="id"  width="40" v-if="false">
      </el-table-column>
      <el-table-column prop="orderNo" label="订单号" width="180" sortable>
      </el-table-column>
      <el-table-column prop="userName" label="购买人姓名" width="120" sortable>
      </el-table-column>
      <el-table-column prop="phone" label="购买人电话" width="120" sortable>
      </el-table-column>
      <el-table-column prop="orderProduct" label="商品名称" width="220" sortable>
      </el-table-column>
      <el-table-column prop="spec" label="商品规格" width="220" sortable>
      </el-table-column>
      <el-table-column prop="number" label="商品数量" width="120" sortable>
      </el-table-column>
      <el-table-column prop="card" label="提货卡卡号" width="120" sortable>
      </el-table-column>
    </el-table>
    <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            @current-change="handleCurrentChange"
            :current-page="query.page"
            :page-size=pagesize
            :total="pageData.total"
            style="position: absolute;margin-left: 500px;margin-top: 20px;">
    </el-pagination>

    <!--===============================修改==========================-->
    <el-dialog :visible.sync="upVisible" :close-on-click-modal="false" style="position: absolute;width: 1200px;left: 180px" :before-close="closeDialog">
    <el-form :model="resform5"  label-width="150px" ref="resform5" id="resform5">
     <!-- <div id="errorimg">
        <img id="error" src="../../assets/error.png" @click="tuichu()">
      </div>-->
      <el-form-item label="订单号:"prop="orderNo"
                    :rules="{
                    required: true, message: '请输入订单号', trigger: 'blur'}" >
        <el-input v-model="resform5.orderNo" clearable></el-input>
      </el-form-item>
      <el-form-item label="购买人姓名:" prop="userName"
                    :rules="{
                    required: true, message: '请输入购买人姓名', trigger: 'blur'}" >
        <el-input v-model="resform5.userName"clearable></el-input>
      </el-form-item>
      <el-form-item label="购买人电话:" prop="phone"
                    :rules="[
            { required: true, message: '请输入购买人电话', trigger: 'blur' },
            { pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, message: '请输入正确的号码格式', trigger: 'change' }
          ]">
        <el-input v-model="resform5.phone"clearable></el-input>
      </el-form-item>
      <el-form-item label="商品名称/规格/数量:" prop="all" :rules="{
                    required: true, message: '请选择商品名称/规格/数量', trigger: 'blur'}">
        <el-cascader
                v-model="resform5.all"
                :options="products"
                :props="productsProps"
                expand-trigger="hover"
                change-on-select
                clearable
        >
        </el-cascader>
      </el-form-item>
     <!-- <el-form-item
              v-for="(name, index) in resform5.productList"
              :key="name.key"
              :label="'商品名称'+index+':'"
              :prop="'productList.'+index+'.name'"
              :rules="{
                    required: true, message: '请输入商品名称', trigger: 'blur'}"
              style="margin-left: 20px"
      >
        <el-input @input="forceUpdate" v-model="name.name"clearable ></el-input>
        <el-button @click.prevent="removeOrderProduct1(name)" style="position: absolute;left: 362px;">删除</el-button>
      </el-form-item>
      <el-form-item
              v-for="(spec, index) in resform5.productList"
              :key="spec.key2"
              :label="'商品规格'+index+':'"
              :prop="'productList.'+index+'.spec'"
              :rules="{
                    required: true, message: '请输入商品规格', trigger: 'blur'}"
              style="margin-left: 20px"
      >
        <el-input @input="forceUpdate"v-model="spec.spec"clearable></el-input>
        <el-button @click.prevent="removeOrderProduct1(spec)" style="position: absolute;left: 362px;">删除</el-button>
      </el-form-item>
      <el-form-item
              v-for="(number, index) in resform5.productList"
              :key="number.key3"
              :label="'商品数量'+index+':'"
              :prop="'productList.'+index+'.number'"
              :rules="{
                    required: true, message: '请输入商品数量', trigger: 'blur'}"
              style="margin-left: 20px"
      >
        <el-input @input="forceUpdate"v-model="number.number"clearable></el-input>
        <el-button @click.prevent="removeOrderProduct1(number)" style="position: absolute;left: 362px;">删除</el-button>
      </el-form-item>-->
      <el-form-item label="提货卡卡号:" prop="card"
                    :rules="{
                    required: true, message: '请输入提货卡卡号', trigger: 'blur'}" >
        <el-input v-model="resform5.card"clearable></el-input>
      </el-form-item>
        <el-button type="primary" style="width: 100%;margin-top: 40px;" @click="reservationUpdate" :loading="resLoading">确定</el-button>
      <!--<el-button type="primary"  style="margin-left: 180px;" @click="addDomain1" >新增商品</el-button>-->
    </el-form>
    </el-dialog>

    <!--===============================新增==========================-->
    <el-dialog id="form6" :visible.sync="addVisible" :close-on-click-modal="false" style="position: absolute;width: 1200px;left: 180px" :before-close="closeDialog">
      <el-form :model="resform6"  label-width="150px"  ref="resform6"  >
        <!--<div id="errorimg1">
          <img id="error1" src="../../assets/error.png" @click="tuichu()">
        </div>-->
        <el-form-item label="订单号:"prop="orderNo"
                      :rules="{
                    required: true, message: '请输入订单号', trigger: 'blur'}"
        >
          <el-input v-model="resform6.orderNo"clearable ></el-input>
        </el-form-item>
        <el-form-item label="购买人姓名:"
                      prop="userName"
                      :rules="{
                    required: true, message: '请输入购买人姓名', trigger: 'blur'}"
        >
          <el-input v-model="resform6.userName"clearable></el-input>
        </el-form-item>
        <el-form-item label="购买人电话:"
                      prop="phone"
                      :rules="[
            { required: true, message: '请输入购买人电话', trigger: 'blur' },
            { pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, message: '请输入正确的号码格式', trigger: 'change' }
          ]"
        >
          <el-input v-model="resform6.phone"clearable></el-input>
        </el-form-item>
        <el-form-item label="商品名称/规格/数量:" prop="all" :rules="{
                    required: true, message: '请选择商品名称/规格/数量', trigger: 'blur'}">
          <el-cascader
                  v-model="resform6.all"
                  :options="products"
                  :props="productsProps"
                  expand-trigger="hover"
                  change-on-select
                  clearable
          >
          </el-cascader>
        </el-form-item>
        <!--<el-form-item
                v-for="(name, index) in resform6.productList"
                :key="name.key"
                :label="'商品名称'+index+':'"
                :prop="'productList.'+index+'.name'"
                :rules="{
                    required: true, message: '请输入商品名称', trigger: 'blur'}"
        >
          <el-input v-model="name.name"></el-input>
          <el-button @click.prevent="removeOrderProduct(name)" style="position: absolute;left: 390px;">删除</el-button>
        </el-form-item>
        <el-form-item
                v-for="(spec, index) in resform6.productList"
                :key="spec.key2"
                :label="'商品规格'+index+':'"
                :prop="'productList.'+index+'.spec'"
                :rules="{
                    required: true, message: '请输入商品规格', trigger: 'blur'}"
        >
          <el-input v-model="spec.spec"></el-input>
          <el-button @click.prevent="removeOrderProduct(spec)" style="position: absolute;left: 390px;">删除</el-button>
        </el-form-item>
        <el-form-item
                v-for="(number, index) in resform6.productList"
                :key="number.key3"
                :label="'商品数量'+index+':'"
                :prop="'productList.'+index+'.number'"
                :rules="{
                    required: true, message: '请输入商品数量', trigger: 'blur'}"
        >
          <el-input v-model="number.number"></el-input>
          <el-button @click.prevent="removeOrderProduct(number)" style="position: absolute;left: 390px;">删除</el-button>
        </el-form-item>-->
        <el-form-item
                label="提货卡卡号:"
                prop="card"
                :rules="{
                    required: true, message: '请输入提货卡卡号', trigger: 'blur'}"
        >
          <el-input v-model="resform6.card"clearable></el-input>
        </el-form-item>
        <el-button type="primary"  style="width: 100%;margin-top: 40px;" @click="reservationAdd('resform6')" :loading="resLoading">确定</el-button>
        <!--<el-button type="primary"  style="margin-left: 180px;" @click="addDomain" >新增商品</el-button>-->
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
  //import NProgress from 'nprogress'
  export default {
    data() {
      return {
        products:[],
        productsProps: {
          value:"id",
          label:"name",
          /*children:[{
            value: "specId",
            label:"spec",
            children: [{
              value: "numberId",
              label: "number" ,
            }]
          }],*/
          multiple: true
        },
        pagesize:10,
        headers:{
          "U-TOKEN":localStorage.getItem("U-TOKEN")
        },
        FormData:{},
        sels: [],
        gaojichaxuntemp:'',
        checked1:false,
        checkedres:[],
        resform5:{
          id:null,
          orderNo:"",
          userName:"",
          phone:"",
          card:"",
          all:[],
         /* productList:[
            {
              name:"",
              spec:"",
              number:"",
            }
          ]*/
          // orderProduct:"",
          // spec:"",
          // number:"",

        },
        resform6:{
          orderNo:"",
          userName:"",
          phone:"",
          card:"",
          all:[],
         /* productList:[
            {
              name:"",
              spec:"",
              number:"",
            }
          ]*/
        },
        checkedres1:{
          all:"全选",
          nores:'未受理',
          alrres:'已受理',
          alrdlv:'已发货'
        },
        province:"",
        city :"",
        area :"",
        listLoading: false,
        selectVisible: false,//查看界面是否显示
        selectLogisticsVisible: false,
        addVisible: false,
        upVisible: false,
        selectdata:{
          detailAddress:"",
          logisticsAddress:"",
          logisticsDate:null,
          deliverTime:null,
          userName: "",
          number: "",
          phone: "",
          card: "",
          address: "",
          userDetailAddress: null,
          orderProduct: "",
          spec: "",
          numberProduct: ""
        },
        selectLogisticsData:[
          {
            time:'',
            status:''
          }
        ],
        resLoading:false,
        logining: false,
        checked: false,
        pageData: {
          total: 0,
          rows: []
        },
        query: {
          page: 1,
          phone: "",
          orderNo: "",
          card:""
        },
        rules5: {
          card: [
            { required: true, message: '请输入提货卡卡号', trigger: 'blur' },
            //{ validator: validaePass2 }
          ],
          orderNo: [
            { required: true, message: '请输入订单号', trigger: 'blur' },
            //{ validator: validaePass2 }
          ],
          phone: [
            { required: true, message: '请输入收件人电话', trigger: 'blur' },
            { pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, message: '请输入正确的号码格式', trigger: 'change' }
            //{ validator: validaePass2 }
          ],
          userName: [
            { required: true, message: '请输入收件人姓名', trigger: 'blur' },
            //{ validator: validaePass }
          ],
          orderProduct: [
            { required: true, message: '请输入商品名称', trigger: 'blur' },
            //{ validator: validaePass2 }
          ],
          spec: [
            { required: true, message: '请输入商品规格', trigger: 'blur' },
            //{ validator: validaePass2 }
          ],
          number: [
            { required: true, message: '请输入商品数量', trigger: 'blur' },
            //{ validator: validaePass2 }
          ],

          fits: ['fill', 'contain', 'cover', 'none', 'scale-down'],
          url: '../../assets/LOGO-800.png'
        },
      };
    },
    methods: {
      tuichu() {
        document.getElementById("products5").style.display = "none";
        document.getElementById("products2").style.display = "none";
      },
      selectIds(orderProduct,spec,number){
        let param = {
          orderProduct:orderProduct,
          spec:spec,
          number:number
        }
        this.$http.post("/productBase/selectIds",param).then(res => {
          if (res.data.success) {
            this.resform5.all = res.data.data
            //console.log(this.resform5.all)
          }else {
          }
        }).catch(error => {
        })
      },
      //显示编辑界面
      handleEdit: function () {
        var ids = this.sels.map(item => item.id);
        //console.log(ids)
        if (ids.length == 0 || ids.length > 1) {
          this.$message({
            message: "请选择一条信息进行修改",
            type: 'error'
          });
          return;
        }
        this.upVisible =true
        //document.getElementById("products5").style.display = "";
        this.resform5.id = this.sels[0].id
        this.resform5.card = this.sels[0].card
        this.resform5.phone = this.sels[0].phone
        this.resform5.userName = this.sels[0].userName
        this.resform5.orderNo = this.sels[0].orderNo
        this.selectIds(this.sels[0].orderProduct,this.sels[0].spec,this.sels[0].number);

        /*this.resform5.productList[0].name = this.sels[0].orderProduct
        this.resform5.productList[0].spec = this.sels[0].spec
        this.resform5.productList[0].number = this.sels[0].number
        if (this.sels[0].orderProduct.indexOf("、") > 0){
          var name1 = this.sels[0].orderProduct.split("、")
          var spec1 = this.sels[0].spec.split("、")
          var number1 = this.sels[0].number.split("、")
          this.resform5.productList[0].name = name1[0]
          this.resform5.productList[0].spec = spec1[0]
          this.resform5.productList[0].number = number1[0]
          console.log(name1[1])
          if (name1[1] != null){
            this.addDomain1();
            this.resform5.productList[1].name = name1[1]
            this.resform5.productList[1].spec = spec1[1]
            this.resform5.productList[1].number = number1[1]
          }
          console.log(name1[2])
          if (name1[2] != null){
            this.addDomain1();
            this.resform5.productList[2].name = name1[2]
            this.resform5.productList[2].spec = spec1[2]
            this.resform5.productList[2].number = number1[2]
          }
          if (name1[3] != null){
            this.addDomain1();
            this.resform5.productList[3].name = name1[3]
            this.resform5.productList[3].spec = spec1[3]
            this.resform5.productList[3].number = number1[3]
          }
          if (name1[4] != null){
            this.addDomain1();
            this.resform5.productList[4].name = name1[4]
            this.resform5.productList[4].spec = spec1[4]
            this.resform5.productList[4].number = number1[4]
          }
          if (name1[5] != null){
            this.addDomain1();
            this.resform5.productList[5].name = name1[5]
            this.resform5.productList[5].spec = spec1[5]
            this.resform5.productList[5].number = number1[5]
          }
        }*/


      },
      //显示查询页面
      handleSelect1: function (index, row) {
        this.selectVisible = true;
        this.selectdata = Object.assign({}, row);
        this.handleClick(index, row)
      },
      /* handleCurrentChange(page) {
         if (this.gaojichaxuntemp.length === 0){
           this.query.page = page
           this.getpagelist();
         }else {
           this.query.page = page
           this.gaojichaxun();
         }
       },*/
      handleCurrentChange(page) {
        this.query.page = page
        //this.getpagelist();
        this.gaojichaxun();
      },
      //获取分页列表
      getpagelist() {
        this.listLoading = true;
        this.$http.post("/order/pagelist", this.query).then(res => {
          if (res.data.success) {
            this.pageData = res.data.data
            this.listLoading = false;
          }else {
            this.$message.error(res.data.message);
          }
        }).catch(error => {
          this.listLoading = false;
          this.$message({message: "数据加载失败[" + error.message + "]", type: 'error'});
        })
      },
      handleClick(index, row) {
        let param = {
          phone: row.phone,
          number: row.logisticsNumber
        }
        this.$http.post("/reservationOrder/selectLogistics", param).then(res => {
          if (res.data.success) {
            var datas = res.data.data;
            this.selectDeliverDetail(param, datas);
          }else {
            this.$message.error(res.data.message);
          }
        }).catch(error => {
          this.$message({message: "数据加载失败[" + error.message + "]", type: 'error'});
        })
      },
      selectDeliverDetail(param, datas) {
        let param1 = {
          number: param.number
        }
        this.$http.post("/reservationOrder/selectDeliverDetail", param1).then(res => {
          if (res.data.success) {
            this.selectdata = res.data.data;
            this.selectdata.detailAddress = datas.detailAddress
            this.selectdata.logisticsAddress = datas.logisticsAddress
            this.selectdata.logisticsDate = datas.logisticsDate
          }else {
            this.$message.error(res.data.message);
          }
        }).catch(error => {
          this.$message({message: "数据加载失败[" + error.message + "]", type: 'error'});
        })
      },
      reservationUpdate() {
        this.$refs.resform5.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.resLoading = true;
              let para = Object.assign({}, this.resform5);
              //console.log(this.resform5)
              this.$http.post("/order/updateOrderProduct", para).then(res => {
                this.resLoading = false;
                if (res.data.success) {
                  this.$message({
                    message: '修改成功',
                    type: 'success'
                  });
                  this.upVisible = false;
                  this.getpagelist();
                  /*window.setTimeout(function () {
                    window.location.reload();
                  },2000)*/
                } else {
                  this.$message.error(res.data.message);
                  this.upVisible = false;
                  this.getpagelist();
                 /* window.setTimeout(function () {
                    window.location.reload();
                  },2000)*/
                }
              })
            }).catch(error => {
              this.$message({
                message: '修改失败',
                type: 'error'
              });
              this.resLoading = false;
              return;
            });
          }
        });
      },
      handleDelete: function () {
        var ids = this.sels.map(item => item.id);
        if (ids.length  < 1) {
          this.$message({
            message: "请至少选择一条数据进行删除",
            type: 'error'
          });
          return;
        }
        this.$confirm('确认删除吗?', '提示', {
          type: 'warning'
        }).then(() => {
          this.$http.post("/order/deleteOrderProduct" , ids).then(result => {
            result = result.data;
            if (result.success) {
              this.$message({
                message: result.message,
                type: 'success'
              });
             /* window.setTimeout(function () {
                window.location.reload();
              },500)*/
              this.query.page = 1;
              this.getpagelist();
            } else {
              this.$message({
                message: result.message,
                type: 'error'
              });
              /*window.setTimeout(function () {
                window.location.reload();
              },500)*/
              this.query.page = 1;
              this.getpagelist();
            }
          }).catch(result => {
            this.$message({
              message: '系统繁忙，稍后重试！！',
              type: 'error'
            });
          })
        }).catch(() => {

        });
      },
      gaojichaxun() {
        //console.log(this.query)
        if (this.gaojichaxuntemp.length == 8) {
          this.query.card = this.gaojichaxuntemp
          this.listLoading = true;
          this.$http.post("/order/pagelist", this.query).then(res => {
            if (res.data.success) {
              this.pageData = res.data.data
              this.listLoading = false;
              this.query.card = ''
            } else {
              this.$message({
                message: res.data.message,
                type: 'error'
              });
              this.listLoading = false;
            }
          }).catch(error => {
            this.listLoading = false;
            this.$message({message: "数据加载失败[" + error.message + "]", type: 'error'});
          });
        } else if (this.gaojichaxuntemp.length == 11) {
          this.query.phone = this.gaojichaxuntemp
          this.listLoading = true;
          this.$http.post("/order/pagelist", this.query).then(res => {
            if (res.data.success) {
              this.pageData = res.data.data
              this.listLoading = false;
              this.query.phone = ''
            } else {
              this.$message({
                message: res.data.message,
                type: 'error'
              });
              this.listLoading = false;
            }
          }).catch(error => {
            this.listLoading = false;
            this.$message({message: "数据加载失败[" + error.message + "]", type: 'error'});
          })
        } else if (this.gaojichaxuntemp.length > 11) {
          this.query.orderNo = this.gaojichaxuntemp
          this.listLoading = true;
          this.$http.post("/order/pagelist", this.query).then(res => {
            if (res.data.success) {
              this.pageData = res.data.data
              this.listLoading = false;
              this.query.orderNo = ''
            } else {
              this.$message({
                message: res.data.message,
                type: 'error'
              });
              this.listLoading = false;
            }
          }).catch(error => {
            this.listLoading = false;
            this.$message({message: "数据加载失败[" + error.message + "]", type: 'error'});
          })
        }else if(this.gaojichaxuntemp.length === 0){
          this.listLoading = true;
          this.$http.post("/order/pagelist", this.query).then(res => {
            if (res.data.success) {
              this.pageData = res.data.data
              this.listLoading = false;
            } else {
              this.$message({
                message: res.data.message,
                type: 'error'
              });
              this.listLoading = false;
            }
          }).catch(error => {
            this.listLoading = false;
            this.$message({message: "数据加载失败[" + error.message + "]", type: 'error'});
          })
        }

      },
      selsChange: function (sels) {
        this.sels = sels;
      },
      /**
       * 导出
       */
      exportExcel() {
        var ids = this.sels.map(item => item.id);
        if (ids < 1) {
          this.$message({
            message: "请至少选择一条未受理的数据进行导出",
            type: 'error'
          });
          return;
        }
        //console.log(ids)
        window.location.href = "/api/excel/exportPartRes" + "?ids=" + ids
        //location.href = "http://localhost:8881/excel/exportPartRes" + "?ids=" + ids
      },
      handleBeforeUpload(file) {
        const uploadLimit = 2
        const uploadTypes = ['xls', 'xlsx']
        const filetype = file.name.replace(/.+\./, '')
        const isRightSize = (file.size || 0) / 1024 / 1024 < uploadLimit
        if (!isRightSize) {
          this.$message.error('文件大小超过 ' + uploadLimit + 'MB')
          return false
        }
        //console.log(filetype.toLowerCase())
        if (uploadTypes.indexOf(filetype.toLowerCase()) === -1) {
          this.$message.warning({
            message: '请上传后缀名为xlsx或xls的附件'
          })
          return false
        }
        return true
      },
      handleExceed() {
        this.$message.warning({
          message: '请选择一个文件上传'
        })
      },
      handlesuccess(){
        this.$message({
          message: '导入成功',
          type: 'success'
        });
        //this.getpagelist();
        //location.reload();
        window.setTimeout(function () {
          window.location.reload();
        },2000)
      },
      handleerror(){
        this.$message({
          message: '导入失败，请仔细核对文件',
          type: 'error'
        });
      },
      shouye(){
        this.$router.push({ path: '/serviceReservationOrder' });
      },
      tiaozhuanyuyue(){
        //this.$router.push({ path: '/cardLogin' });
        location.href = "https://ahyfyx.com/#/cardLogin"
      },
      handleadd(){
        //document.getElementById("products2").style.display = "";
        this.addVisible = true;
      },
      closeDialog(done){
        this.$confirm('确认关闭？')
                .then(_ => {
                  done();
                  location.reload();
                })
                .catch(_ => { });
      },
      addDomain() {
        this.resform6.productList.push({
          /* key:Date.now(),
           key2:Date.now()+1,
           key3:Date.now()+2*/
        });
      },
      addDomain1() {
        this.resform5.productList.push({
        }
                //this.resform5.productList[1].name = ""
        );
      },
      removeOrderProduct(item) {
        var index = this.resform6.productList.indexOf(item)
        if (index !== -1) {
          this.resform6.productList.splice(index, 1)
        }
      },
      removeOrderProduct1(item) {
        var index = this.resform5.productList.indexOf(item)
        if (index !== -1) {
          this.resform5.productList.splice(index, 1)
        }
      },
      reservationAdd(resform6){
        this.$refs[resform6].validate((valid) => {
          if (valid) {
            //console.log(this.resform6)
            this.$confirm('确认添加吗?', '提示', {}).then(() => {
              this.$http.post("/order/orderProduct", this.resform6).then(result => {
                result = result.data;
                if (result.success) {
                  this.$message({
                    message: '添加成功',
                    type: 'success',
                  });
                  this.$refs.resform6.resetFields();
                  this.addVisible = false;
                  this.getpagelist();
                } else {
                  this.$message({
                    message: result.message,
                    type: 'error'
                  });
                  this.$refs.resform6.resetFields();
                  this.addVisible = false;
                  this.getpagelist();
                }
              }).catch(result => {
                this.$message({
                  message: '系统繁忙，稍后重试！！',
                  type: 'error'
                });
                this.$refs.resform6.resetFields();
                this.addVisible = false;
              })
            }).catch(() => {

            });
          }
        });
      },
      //退出登录
      logout: function () {
        this.$confirm('确认退出吗?', '提示', {
          //type: 'warning'
        }).then(() => {
          localStorage.removeItem('loginInfo');
          localStorage.removeItem('U-TOKEN');
          localStorage.removeItem('permissions');
          //====================退出的时候需要刷新一下本地的路由缓存
          //location.reload();
          //================
          this.$router.push({ path: '/login' });
        }).catch(() => {
        });
      },
      forceUpdate() {
        this.$forceUpdate()
      },
      getTreeData(){
        this.$http.get("/productBase/treeData").then(res => {
          if (res.data.success) {
            this.products = res.data.data;
          }else {
            this.$message.error(res.data.message);
          }
        }).catch(error => {
          this.$message({message: "数据加载失败[" + error.message + "]", type: 'error'});
        })
      },
    },
    mounted() {
      this.getpagelist();
      this.getTreeData();
    }
  }

</script>

<style lang="scss" scoped>
  #products2{
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 100px auto;
    width: 350px;
    padding: 37px 90px 35px 15px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
  }
  #products5{
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 30px auto;
    width: 550px;
    padding: 40px 50px 35px 45px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
  }
  #loginbg{
    background-image: url('../../assets/login.png');
    background-position: center;
    background-size:  100% 100%;
    background-repeat: no-repeat;
    height: 100%;
    //background-color: black;
  }
  #ding{
    background-color: #303133;
    height: 58px;
    margin-top: -18px;
  }
  #wenzi{
    position: absolute;
    margin-top: 18px;
    font-size: large;
    color: white;
    left: 100px;
    font-family: "PingFang SC";
    font-weight: 600;
  }
  #zhanghao{
    position: absolute;
    margin-top: 20px;
    font-size: 16px;
    color: white;
    left: 1100px;
    font-family: "PingFang SC";
    font-weight: 400;
  }
  #tuichu{
    position: absolute;
    margin-top: 20px;
    font-size: 16px;
    color: white;
    left: 1180px;
    font-family: "PingFang SC";
    font-weight: 400;
    cursor:pointer
  }
  #tuichu:hover {
    color: #c1e9f8;
  }
  #yuyue{
    position: absolute;
    margin-top: 20px;
    font-size: 16px;
    color: white;
    left: 250px;
    font-family: "PingFang SC";
    font-weight: 400;
    cursor:pointer
  }
  #yuyue:hover {
    color: #c1e9f8;
  }
  #errorimg{
    position: absolute;
    left: 610px;
    top: 15px;
  }
  #errorimg1{
    position: absolute;
    left: 380px;
    top: 15px;
  }
  #fengexian{
    position: absolute;
    top: 102px;
    width: 85%;
    left: 110px;
  }
  #basic{
    position: absolute;
    margin-top: 20px;
    font-size: 16px;
    color: white;
    left: 350px;
    font-family: "PingFang SC";
    font-weight: 400;
    cursor:pointer
  }
  #basic:hover {
    color: #c1e9f8;
  }
</style>



// WEBPACK FOOTER //
// ServiceProductOrder.vue?0f2834a8